export default "__VITE_ASSET__0e36cae0__"